import { invokeApi } from "../../bl_libs/invokeApi";
export const AllExerciseListingApi = async (
  page,
  limt,
  search,
  data,
  status
) => {
  const requestObj = {
    path: `api/exercise/exercises?page=${page}&limit=${limt}&search=${search}&status=${status}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const ExerciseListingApi = async (page, limt, search, data) => {
  const requestObj = {
    path: `api/exercise/active_exercise?page=${page}&limit=${limt}&search=${search}&sort=asc`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const exercise_detail_api = async (slug) => {
  const requestObj = {
    path: `api/exercise/${slug}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const recordingListApi = async (slug) => {
  const requestObj = {
    path: `api/lesson_recording/${slug}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const recordingDetailApi = async (slug) => {
  const requestObj = {
    path: `api/lesson_recording/recording_detail/${slug}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const AddExerciseApi = async (data) => {
  const requestObj = {
    path: `api/exercise`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const AddLessonRecordingApi = async (data) => {
  const requestObj = {
    path: `api/lesson_recording/`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const EditLessonRecordingApi = async (data, slug) => {
  const requestObj = {
    path: `api/lesson_recording/${slug}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const EditExerciseApi = async (data, slug) => {
  const requestObj = {
    path: `api/exercise/${slug}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const deleteExerciseApi = async (slug) => {
  const requestObj = {
    path: `api/exercise/${slug}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const lessonRecordingDelete = async (slug) => {
  const requestObj = {
    path: `api/lesson_recording/${slug}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const save_target_weight_api = async (data) => {
  const requestObj = {
    path: `api/member/save_target_weight`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const add_weight_api = async (data) => {
  const requestObj = {
    path: `api/weight`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_weight_api = async (data, id) => {
  const requestObj = {
    path: `api/weight/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const get_weight_list_api = async (page, limt, time, start, end) => {
  const requestObj = {
    path: `api/weight?page=${page}&limit=${limt}&range=${time}&weight_start_date=${start}&weight_end_date=${end}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const del_weight_list_api = async (id) => {
  const requestObj = {
    path: `api/weight/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
